<template>
    <div>
        <div class="h-content">
            <!--查询表单-->
            <div class="h-piece">
                <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                    <div class="h-thirdColumn w-newColumn">
                        <el-form-item label="经销商名称/编码">
                            <el-input v-model="q.agentNameLike" placeholder="请输入编码或名称" :clearable="true"></el-input>
                        </el-form-item>
                        <el-form-item label="渠道">
                            <brselect category="fl_sales_region_main" :v="q.salesRegionCode" v-model="q.salesRegionCode"
                                      :multiple="true" :clearable="true"/>
                        </el-form-item>
                        <el-form-item label="区域">
                            <brselect category="YLRegion" :v="q.areaCode" v-model="q.areaCode"
                                      :multiple="true" :clearable="true"/>
                        </el-form-item>

                        <el-form-item label="年份">
                            <el-select filterable v-model="q.year" clearable placeholder="请选择">
                                <el-option value="2020">
                                </el-option>
                                <el-option value="2021">
                                </el-option>
                                <el-option value="2022">
                                </el-option>
                                <el-option value="2023">
                                </el-option>
                                <el-option value="2024">
                                </el-option>
                                <el-option value="2025">
                                </el-option>
                                <el-option value="2026">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </el-form>
                <div class="l-screenBox">
                    <div class="l-screen" @click="collapseChange">
                        <img :src="isScreen?closeScreen:drawScreen" alt="">
                        <div class="l-screenText">{{ isScreen ? "收起" : "展开" }}</div>
                    </div>
                    <div class="l-retrieval">
                        <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                        <el-button class="h-btn h-formBtn h-bgwhite" @click="qingkong">重置</el-button>
                    </div>
                </div>
            </div>
            <!--展示表格-->
            <div class="h-table h-mrt30 sjwstyle">
                <el-table
                    ref="ddtable"
                    :data="tableData"
                    stripe
                    style="width: 100%"
                    :border="true"
                    max-height="520">
                    <el-table-column
                        type="index"
                        label="#"
                        fixed
                        width="40">
                    </el-table-column>
                    <el-table-column
                        prop="area"
                        label="区域"
                        :show-overflow-tooltip="true"
                        fixed
                        width="80">
                    </el-table-column>
                    <el-table-column
                        prop="agentCode"
                        label="经销商编码"
                        :show-overflow-tooltip="true"
                        fixed
                        width="110">
                    </el-table-column>
                    <el-table-column
                        prop="agentName"
                        label="经销商名称"
                        :show-overflow-tooltip="true"
                        fixed
                        width="180">
                        <template slot-scope="scope">
                            <div style="text-align: left;">
                                {{ scope.row.agentName }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="agentType"
                        label="经销商类型"
                        :show-overflow-tooltip="true"
                        width="100">
                        <template slot-scope="scope">
                            {{ scope.row.agentType|dictname('fl_agent_type') }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="salesRegionCode"
                        label="渠道"
                        :show-overflow-tooltip="true"
                        width="100">
                        <template slot-scope="scope">
                            {{ scope.row.salesRegionCode|dictname('fl_sales_region_qudao') }}
                        </template>
                    </el-table-column>

                    <!--按月/季度分组的同期、目标、实际、履约率-->
                    <el-table-column
                        v-for="item in periodColumns"
                        :key="item.label"
                        :label="item.label">
                        <el-table-column
                            :prop="item.tongqi"
                            label="同期(万元)"
                            width="90"
                            align="right">
                            <template slot-scope="scope">
                                {{ formatMoney(sumRaw(scope.row, 'salesVolume', item.months)) }}
                            </template>
                        </el-table-column>
                        <el-table-column
                            :prop="item.goal"
                            label="目标(万元)"
                            width="90"
                            align="right">
                            <template slot-scope="scope">
                                {{ formatMoney(sumRaw(scope.row, 'goal', item.months)) }}
                            </template>
                        </el-table-column>
                        <el-table-column
                            :prop="item.actual"
                            label="实际(万元)"
                            width="90"
                            align="right">
                            <template slot-scope="scope">
                                {{ formatMoney(sumRaw(scope.row, 'actual', item.months)) }}
                            </template>
                        </el-table-column>
                        <el-table-column
                            :prop="item.lvyuelv"
                            label="履约率(%)"
                            width="90"
                            align="right">
                            <template slot-scope="scope">
                                {{ calcRate(sumRaw(scope.row, 'actual', item.months), sumRaw(scope.row, 'goal', item.months)) }}
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column
                        prop="qunianTongqi"
                        label="去年同期(万元)"
                        :show-overflow-tooltip="true"
                        width="110"
                        align="right">
                        <template slot-scope="scope">
                            {{ formatMoney(scope.row.qunianTongqi) }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="jinnianGoal"
                        label="全年目标(万元)"
                        :show-overflow-tooltip="true"
                        width="110"
                        align="right">
                        <template slot-scope="scope">
                            {{ formatMoney(scope.row.jinnianGoal) }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="yearActual"
                        label="全年实际(万元)"
                        :show-overflow-tooltip="true"
                        width="110"
                        align="right">
                        <template slot-scope="scope">
                            {{ formatMoney(scope.row.yearActual) }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="全年履约率(%)"
                        width="110"
                        align="right">
                        <template slot-scope="scope">
                            {{ calcRate(scope.row.yearActual, scope.row.jinnianGoal) }}
                        </template>
                    </el-table-column>
                </el-table>
                <div class="h-tableB h-mrt30">
                    <div class="h-tableBL">
                        <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export"
                                   @click="uploaddownexcelflagbtn"
                                   v-auth="'fllb_daoruXsjl'"
                        >批量导入
                        </el-button>
                        <uploaddownexcel
                            :visible.sync="uploaddownexcelflag"
                            v-if="uploaddownexcelflag"
                            clsname="industryImportExcel"
                            :extparams="extparams"
                            :startrow="2" @callback="uploadExcelFilecallback" />



                    </div>
                    <div class="h-pagination2">
                        <pagination :page="q" @query="query"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import industryImport from "@/api/loud/agent/industryImport.js";
import uploaddownexcel from '@/components/uploaddown/uploaddownexcel'

// 生成表头分组：1月、Q1、2月、3月、4月、Q3 ... 12月、Q4
function buildPeriodColumns() {
    const list = [];
    for (let m = 1; m <= 12; m++) {
        list.push({
            label: m + '月',
            months: [m]
        });
        if (m % 3 === 0) {
            list.push({
                label: 'Q' + m / 3,
                months: [m - 2, m - 1, m]
            });
        }
    }
    return list;
}
export default {
    components: {uploaddownexcel},
    props: {
        // 所属产业：KS康盛/YX元析/SD三大/JWX金卫信
        contractId: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            uploaddownexcelflag: false,
            extparams: {contractId: this.contractId},
            // 展开折叠筛选
            isScreen: false,
            closeScreen: require("@/assets/images/pimg/closeallic.png"),
            drawScreen: require("@/assets/images/pimg/dobleArr.png"),
            // 表头分组配置
            periodColumns: buildPeriodColumns(),
            //查询属性
            q: {
                contractId: this.contractId,
                agentNameLike: '',
                agentType: null,
                salesRegionCode: [],
                areaCode: [],
                belongIndustry: [],
                year: 2026,
                pageSize: 10,
                pageNo: 1,
                total: 0
            },
            //table列表
            tableData: []
        }
    },
    created() {
        this.query();
    },
    watch: {
        contractId(val) {
            this.q.contractId = val;
            this.extparams.contractId = val;
            this.q.pageNo = 1;
            this.query();
        }
    },
    methods: {
        // 展开折叠
        collapseChange() {
            this.isScreen = !this.isScreen;
        },
        query() {
            industryImport.query(this.q).then(rd => {
                this.q.total = rd.total;
                this.tableData = rd.records;
            });
        },
        //导入
        uploaddownexcelflagbtn() {
            this.uploaddownexcelflag = true;
        },
        uploadExcelFilecallback(){
            this.query();
        },

        // 检索
        handleFilter() {
            this.q.pageNo = 1;
            this.query();
        },
        // 重置
        qingkong() {
            this.q = {
                contractId: this.contractId,
                agentNameLike: '',
                agentType: null,
                salesRegionCode: [],
                areaCode: [],
                belongIndustry: [],
                year: 2026,
                pageSize: 10,
                pageNo: 1,
                total: 0
            };
            this.query();
        },

        sumRaw(row, prefix, months) {
            let total = 0;
            let hasValue = false;
            months.forEach(m => {
                const v = row[prefix + m];
                if (v !== null && v !== undefined && v !== '') {
                    total += Number(v) || 0;
                    hasValue = true;
                }
            });
            return hasValue ? Math.round(total * 100) / 100 : null;
        },
        // 金额展示，空值不显示
        formatMoney(value) {
            if (value === null || value === undefined || value === '') {
                return '';
            }
            const num = Number(value);
            return isNaN(num) ? value : Math.round(num * 100) / 100;
        },
        // 履约率 = 实际 / 目标 * 100，目标为空或为 0 时不显示
        calcRate(actual, goal) {
            if (actual === null || actual === undefined || actual === '' ||
                goal === null || goal === undefined || goal === '') {
                return '';
            }
            const a = Number(actual);
            const g = Number(goal);
            if (isNaN(a) || isNaN(g) || g === 0) {
                return '';
            }
            return (a / g * 100).toFixed(2) + '%';
        }



    }
}
</script>
<style>
.sjwstyle .el-table thead.is-group th {
    background: #57aefe;
}
</style>
